import { Amenity } from "@app/models/Amenity";
import { AmenityNameCatalog } from "@app/models/AmenityNameCatalog";
import { PaymentRequestDetail } from "@app/models/PaymentRequestDetail";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class AmenityService {

    getAvailableCategories(amenities: Amenity[]): AmenityNameCatalog[] {
        let categories: AmenityNameCatalog[] = []
        amenities.forEach(amenity => {
            let push = true;
            categories.forEach(category => {
                if (category.id === amenity.amenityNameCatalog.id)
                    push = false;
            })
            if (push)
                categories.push(amenity.amenityNameCatalog);
        })

        categories.sort((a,b) => {
            if (a.description.toLowerCase() < b.description.toLowerCase()) return -1;
            if (a.description.toLowerCase() > b.description.toLowerCase()) return 1;
            return 0;
        })

        categories.unshift({ id:null, description:"All" })

        return categories;
    }

    validateCartItems(amenities: Amenity[], cartItems: PaymentRequestDetail[]) {
        cartItems.forEach(cartItem => {
            let amenity = amenities.find(amenity => amenity.id === cartItem.entityId);
            if (amenity != null) {
                cartItem.inventoryCount = amenity.count;
            }
            this.validateCartItem(cartItem)
        });
    }

    validateCartItem(cartItem: PaymentRequestDetail) {
        if (cartItem.inventoryCount != null && cartItem.qty > cartItem.inventoryCount) {
            cartItem.qtyError = cartItem.inventoryCount  + " in stock";
        } else {
            cartItem.qtyError = null;
        }
    }

    invalid(cartItems: PaymentRequestDetail[]) {
        if (cartItems && cartItems.length > 0)
            return this.hasQtyError(cartItems);
        else
            return true;
    }

    hasQtyError(cartItems: PaymentRequestDetail[]) {
        let invalidCart = false;
        cartItems.forEach(cartItem => {
            if (cartItem.qtyError)
                invalidCart = true;
        });
        return invalidCart;
    }

}


